import { defaultBorderRadius } from '../../common/props';

var getModalHeight = function getModalHeight(_ref) {
  var modalHeight = _ref.modalHeight,
      anchorHeight = _ref.anchorHeight,
      height = _ref.height;

  if (!modalHeight || !anchorHeight) {
    return height;
  }

  if (height === 'auto' && anchorHeight > modalHeight) {
    return 'auto';
  }

  return "".concat(anchorHeight, "px");
};

var getModalBorderRadius = function getModalBorderRadius(props) {
  switch (props.isFullScreen) {
    case true:
      return '0';

    default:
      return defaultBorderRadius;
  }
};

var getTopPosition = function getTopPosition(_ref2) {
  var top = _ref2.top,
      modalHeight = _ref2.height;
  var viewportHeight = window.innerHeight;
  var maxHeight = viewportHeight;
  var isOutOfBoundsOfMaxHeight = modalHeight > maxHeight;
  var doesModalOverflowViewportHeight = viewportHeight < top + modalHeight;

  if (isOutOfBoundsOfMaxHeight) {
    return 0;
  }

  if (doesModalOverflowViewportHeight) {
    return viewportHeight - modalHeight;
  }

  return top;
};

var alignActionItems = function alignActionItems(props) {
  switch (props.alignActions) {
    case 'left':
      return 'start';

    case 'right':
      return 'end';

    case 'center':
      return 'center';

    default:
      return 'right';
  }
};

export default {
  alignActionItems: alignActionItems,
  getModalBorderRadius: getModalBorderRadius,
  getModalHeight: getModalHeight,
  getTopPosition: getTopPosition
};